import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const PopoverWrapper = styled.div`
    z-index: 10;
`;

export const PopoverInside = styled(motion.div)<{ $allowOverflow?: boolean }>`
    box-shadow: 0 0 30px 5px rgba(2, 1, 5, 0.5);
    border-radius: 20px;
    background-color: #151327;
    width: 330px;
    overflow: hidden;
    z-index: 10;

    ${({ $allowOverflow }) =>
        $allowOverflow &&
        css`
            overflow: visible;
        `}
`;
